import { Injectable } from '@angular/core';

/**
 * Servicio utilitario para detectar el tipo de dispositivo desde el que se
 * accede a la aplicacion (movil, tablet o touch), en base al user agent del
 * navegador. Se usa, por ejemplo, para adaptar la UI en paginas especificas
 * o para enriquecer los eventos enviados a Google Analytics (ver
 * GaTrackingService).
 */
@Injectable({ providedIn: 'root' })
export class DeviceService {
  private ua = navigator.userAgent;

  isMobile(): boolean {
    return /Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|webOS/i.test(this.ua);
  }

  isTablet(): boolean {
    return /iPad|Android(?!.*Mobile)|Tablet/i.test(this.ua);
  }

  isMobileOrTablet(): boolean {
    return this.isMobile() || this.isTablet();
  }

  // Complemento: detecta si el dispositivo soporta touch
  isTouchDevice(): boolean {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  }

  // La combinacion mas confiable para tu caso.
  // OJO: no usar isTouchDevice() en OR aqui. Muchos navegadores de escritorio
  // (laptops/monitores con pantalla tactil, o ciertos builds de Chrome/Edge
  // en Windows) reportan 'ontouchstart' o maxTouchPoints > 0 aunque el
  // dispositivo sea un desktop real, lo que provocaba falsos positivos de
  // "movil" en desktop. El user agent es la senal confiable; el touch solo
  // se usa como refuerzo cuando ademas el viewport es angosto (tipico de
  // moviles/tablets reales).
  shouldEnableMobileFeatures(): boolean {
    const narrowViewport = window.innerWidth <= 1024;
    return this.isMobileOrTablet() || (this.isTouchDevice() && narrowViewport);
  }

  /**
   * Etiqueta legible del tipo de dispositivo, util como dimension/label
   * en eventos de analytics o logs.
   */
  getDeviceType(): 'mobile' | 'tablet' | 'desktop' {
    if (this.isMobile()) {
      return 'mobile';
    }
    if (this.isTablet()) {
      return 'tablet';
    }
    return 'desktop';
  }
}
